import { RedirectData, PdfItem } from '../hooks/useChat';

const PDF_EXTENSION_PATTERN = /\.pdf(\?|#|$)/i;

/**
 * Command REDIRECT dạng mới: `deeplink_web` trỏ thẳng tới 1 file PDF (vd. sổ tay thuế agent TAX_QUESTION).
 * Dạng cũ (deeplink có `params.taxs` là danh sách PDF) đi qua extractPdfRedirectData.
 */
export const extractDirectPdfUrl = (command: any): string | null => {
  if (!command || command.type !== 'REDIRECT') return null;

  const deeplinkWeb = (command.commandVariables || [])
    .find((v: any) => v.name === 'deeplink_web')?.value;
  if (typeof deeplinkWeb !== 'string' || !deeplinkWeb.trim()) return null;

  const url = deeplinkWeb.trim();
  return PDF_EXTENSION_PATTERN.test(url) ? url : null;
};

export const extractPdfRedirectData = (command: any): RedirectData | null => {
  if (!command || command.type !== 'REDIRECT') return null;

  const commandVariables = command.commandVariables || [];
  const deeplinkVar = commandVariables.find((v: any) => v.name === 'deeplink_ios')
    || commandVariables.find((v: any) => v.name === 'deeplink_android');

  if (deeplinkVar?.value) {
    try {
      const url = new URL(deeplinkVar.value);
      const paramsStr = url.searchParams.get('params');

      if (paramsStr) {
        const params = JSON.parse(paramsStr);
        const type = params.type || 'unknown';

        let items: PdfItem[] = [];
        if (params.taxs && Array.isArray(params.taxs)) {
          items = params.taxs.map((tax: any) => ({
            title: tax.title,
            uri: tax.uri,
          }));
        }

        return {
          type,
          items,
          commandName: command.name,
        };
      }
    } catch (error) {
      console.error('[CommandUtils] Error parsing deeplink:', error);
    }
  }

  return null;
};
